export enum SnackbarActionTypes {
  OPEN_SNACKBAR = 'OPEN_SNACKBAR',
  CLOSE_SNACKBAR = 'CLOSE_SNACKBAR',
}

export type SnackbarStateType = {
  open?: boolean
  message: any
  severity: 'error' | 'success' | 'info' | 'warning'
  autoHideDuration?: number
}
